
(function fileDownloaderModuleDefinition() {

    angular.module('FileDownloader', []);

})();